import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { ApiResponseContainer } from '@bhtp-client-api/base';
import { BhtpBaseTypeaheadService } from '@bhtp-client-api/typeahead';
import { ApiAgentInformation } from '../models';
import { Observable } from 'rxjs';

@Injectable()
export abstract class BaseAgentTypeaheadService extends BhtpBaseTypeaheadService<ApiAgentInformation> {
    public readonly agentNameSearch: string = 'name';
    public readonly agentCodeSearch: string = 'code';

    constructor(private http: Http) {
        super();
    }

    public search(searchValue: string): Observable<ApiAgentInformation[]> {
        let searchBy: string = this.getSearchBy();

        let url: string = this.getFullUrl(`/v1/Agents/${searchBy}/${encodeURIComponent(searchValue)}`);
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);

        return this.http.get(url, options).map((res) => {
            let response: ApiResponseContainer<ApiAgentInformation[]> = <ApiResponseContainer<ApiAgentInformation[]>>res.json();
            return response.response;
        });
    };

    public abstract getSearchType(): string;

    private getSearchBy(): string {
        let searchType: string = this.getSearchType();
        let searchBy: string;

        if (searchType && searchType.toLowerCase() === this.agentCodeSearch) {
            searchBy = this.agentCodeSearch;
        } else {
            searchBy = this.agentNameSearch;
        }

        return searchBy;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/base-agent-typeahead.service.ts